const UNSCROLLABLE_CLASS = 'unscrollable';

export const preventScroll = (isOpenModal: boolean) => {
  const { body } = document;
  const classAttribute = body.getAttribute('class');

  if (isOpenModal) {
    if (classAttribute && classAttribute.includes(UNSCROLLABLE_CLASS)) {
      return;
    }
    body.setAttribute('class', `${classAttribute || ''} ${UNSCROLLABLE_CLASS}`.trim());
    return;
  }

  if (!classAttribute) {
    return;
  }
  body.setAttribute('class', `${classAttribute}`.replace(UNSCROLLABLE_CLASS, ''));
};
